import { render } from "./lead-assignment-location-rule.vue?vue&type=template&id=031673d8"
import script from "./lead-assignment-location-rule.vue?vue&type=script&lang=js"
export * from "./lead-assignment-location-rule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__